import { useState, useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import OtpInput from './OtpInput';
import { getDeviceType } from '../Common/CommonHooks';

import LoginLoading from '../Common/ui-components/LoginLoading';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';


export const SecurityPin = ({
    showMsg = false,
    onClickNext,
    invalidPIN,
    setInvalidPIN,
    pin,
    setPin,
    verifyPinLoading,
    onClickCancelSecurityPin,
    setShowLoginLockPopup,
    setShowErrorPopup,
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [clearPIN, setClearPIN] = useState(true);
    const [isClicked,setIsClicked] = useState(false);
    const device = getDeviceType();
    const isMobile = !device.isTablet && !device.isDesktop
    let mobileStyle = isMobile ? 'is-mobile' : 'is-desktop';

    const { sendAdobeEvent } = useAdobeLaunch()

    useEffect(() => {
        window.sessionStorage.setItem("LoginWA","eWin_login_whitelistWithMobile");
        sendAdobeEvent({
            event: 'interaction',
            interaction: { eventID: 'eWin_CIAM_S1c-PIN_whitelistWithMobile' }
        });
    },[]);

    useEffect(() => {
        if (isMobile) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobile]);

    const clearPINInput = () => {
        if (!invalidPIN || !clearPIN) {
            console.debug('invalidPIN, clearPIN', invalidPIN, clearPIN)
            return;
        }
        setPin('');
        setClearPIN(false);
        setInvalidPIN(false)
    }

    useEffect(() => {
        if(invalidPIN.length>0){
            if(invalidPIN.includes("ERR"))
                invalidPIN = invalidPIN.replace("ERR",'')
        }
        setClearPIN(true);
        if(invalidPIN=='100017'){
          invalidPIN=""
          setShowLoginLockPopup(true)
          onClickCancelSecurityPin()
        }
        else if(invalidPIN=='100019'||invalidPIN=='100020'){
            setShowErrorPopup(invalidPIN + '|'+ invalidPIN);
            invalidPIN=""
            setClearPIN(false);
            setInvalidPIN(false);
            setPin('');
        }
    }, [invalidPIN])

    useLayoutEffect(() => {
        if (pin.length >= 6) {
          // Manually unfocus the input box
          console.debug('unfocus pin input')
          document.activeElement.blur();
          // check pin
          onClickNext();
        }
      }, [pin]);

    useEffect(() => {
        const device = getDeviceType();

        // if (device.isTablet) {
        //     setAccountOpeningURL('#');
        // } else if (device.isDesktop) {
        //     setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_MHKJC'));
        // } else {
        //     setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_SH'));
        // }
        // setAccountOpeningURL('#'); // testing
    }, [navigator.platform, navigator.userAgent]);

    return (
        <>
      
        <Popup open={showMsg}  closeOnEscape={false} closeOnDocumentClick={false} className={`comingSoonLogOutDialog logout-succ-msg otp-popup otp-popup-content  ${invalidPIN ? 'otp-invalid' : ''} ${mobileStyle}`}>
            <div className={`otp-popup-container ${invalidPIN ? 'otp-invalid' : ''}`}>
                {
                    verifyPinLoading && <LoginLoading className='login-center'></LoginLoading>
                }
                <div className="otp-title" id="AuthTitle">{t('LB_PIN_0')}</div>
                {/* <div className="otp-1" id="Auth_content_prompt" dangerouslySetInnerHTML={{ __html: t(isVoiceOTP? 'LB_OTP_8' :'LB_OTP_1') + `<b>${getMobile()?.mobileNo}</b>`}} ></div>*/}
                <div className="pin-pleaseinput" id="code_label">{t('LB_PIN_1')}</div> 
                <div id="code_input_box" style={{ marginTop: '8px' }}>
                    <OtpInput
                        value={pin}
                        onValueChange={(o) => {
                            setInvalidPIN(false)
                            setPin(o)
                        }}
                        isPin
                        onRefClick={clearPINInput}
                        isError={invalidPIN}
                        enableAutoComplete={true}
                    />
                </div>
                {invalidPIN && <div className='otp-invalid-code'
                    dangerouslySetInnerHTML={{
                        __html: t('LB_PIN_ERR'+invalidPIN)
                    }}
                id="code_tips"></div>}
                
                <div className="otp-didnotreceive" id="code_resend_ask"></div>
                <div 
                    className={`otpauth-button resent`}
                    id="code_resend"
                >
                    <span>{t('LB_PIN_2')}</span>
                    {/* {resent && <span> ({formatResendTimer()})</span>} */}
                </div>
                
                {/* <div className="otpauth-trouble" 
                    onClick={()=> {
                        setIsShowTroublePopup(true);                        
                        sendAdobeEvent({
                            event: "interaction",
                            interaction: { eventID: 'eWin_CIAM_S1a-OTP-clickTrouble_whitelistWithMobile' }
                        });
                    }}
                >
                    <img className='img-trouble' src={iconOtpTrouble} alt="" />
                    <div>
                        {isVoiceOTP ?
                        <div className='otpauth-trouble-iconBox'>
                            {t( 'LB_OTP_TROUBLE_CHANGE3')}
                        </div>: 
                        <div className='otpauth-trouble-iconBox'>
                            {t('LB_OTP_TROUBLE_CHANGE1')}
                        </div> }
                        <div> 
                            {t('LB_OTP_TROUBLE_CHANGE2')}
                        </div>
                    </div>                   
                </div> */}
                <div className="otpauth-button otpauth-cancel mt-3" onClick={onClickCancelSecurityPin} id="Cancel">{t('LB_PIN_CANCEL')}</div>

            </div>
        </Popup>
        </>
    );
};